/* ------------------------------------------------------------------
   ENGRAVING CART SYNC (UpCart-aware)
   --------------------------------------------------------------------
   The Custom Engraving add-on (ENG-ADDON-001) is a real charged line item,
   linked to its bracelet via the `_engraving_group` property. This keeps
   the pair in step and keeps the add-on invisible in the UpCart drawer:

   1. Orphan removal — bracelet gone → its engraving line is removed.
   2. Quantity sync  — engraving quantity always matches its bracelet.
   3. UpCart display — the ENG-ADDON-001 tile is hidden inside UpCart's
      shadow root, and a small "Engraving: …" summary is written onto the
      bracelet tile instead (the order data itself is untouched).
------------------------------------------------------------------ */
(function () {
  var ENGRAVING_VARIANT = 44430693171340;
  var LINK_KEY = '_engraving_group';
  var TEXT_KEY = '_Engraving text ';
  var FONT_KEY = '_Font selection';
  var syncing = false;

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  async function syncEngraving() {
    if (syncing) return;
    syncing = true;
    var changed = false;
    try {
      var cart = await fetch(root() + 'cart.js').then(function (r) { return r.json(); });

      // Lines added before 17 Sep 2026 carry the old Easify contract
      // (_po:items:addon): Easify merges the engraving into the bracelet line
      // at a converted AUD price, and the second-bracelet discount does not
      // land on a merged line. Rebuild each one as bracelet + real engraving
      // line so the customer pays the market price and gets the saving.
      var migrated = false;
      for (var m = 0; m < cart.items.length; m++) {
        var ol = cart.items[m];
        var op = ol.properties || {};
        if (!op['_po:items:addon'] || ol.variant_id === ENGRAVING_VARIANT) continue;
        var grpNew = 'eng-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
        var np = {};
        np['_Add engraving'] = op['Add engraving'] || op['_Add engraving'] || 'Custom Engraving';
        np['_Font selection'] = op['Font selection'] || op['_Font selection'] || '';
        np['_Engraving text '] = op['Engraving text '] || op['_Engraving text '] || '';
        np['_Confirmation '] = op['Confirmation '] || op['_Confirmation '] || '';
        np[LINK_KEY] = grpNew;
        if (np['_Engraving text ']) np['Engraving'] = '\u201C' + np['_Engraving text '] + '\u201D' + (np['_Font selection'] ? ' \u00B7 ' + np['_Font selection'] : '');
        var engProps = {}; engProps[LINK_KEY] = grpNew;
        await fetch(root() + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: ol.key, quantity: 0 })
        });
        await fetch(root() + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [
            { id: ol.variant_id, quantity: ol.quantity, properties: np },
            { id: ENGRAVING_VARIANT, quantity: ol.quantity, properties: engProps }
          ] })
        });
        migrated = true; changed = true;
      }
      if (migrated) cart = await fetch(root() + 'cart.js').then(function (r) { return r.json(); });

      // Pair up bracelet + engraving lines by group id.
      // Shopify can SPLIT a bracelet line into several lines that share one
      // group (it does this when an automatic discount applies to only some
      // of the units), so bracelet quantity is summed across the group.
      var pairs = {};
      cart.items.forEach(function (it) {
        var grp = it.properties && it.properties[LINK_KEY];
        if (!grp) return;
        pairs[grp] = pairs[grp] || { braQty: 0 };
        if (it.variant_id === ENGRAVING_VARIANT) pairs[grp].eng = it;
        else pairs[grp].braQty += it.quantity;
      });

      for (var grp in pairs) {
        var p = pairs[grp];
        if (p.eng && p.braQty === 0) {
          // Orphaned engraving → remove
          await fetch(root() + 'cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: p.eng.key, quantity: 0 })
          });
          changed = true;
        } else if (p.eng && p.eng.quantity !== p.braQty) {
          // Quantity drift → one engraving charge per bracelet in the group
          await fetch(root() + 'cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: p.eng.key, quantity: p.braQty })
          });
          changed = true;
        }
      }

      // Stray engraving line with no group at all → remove (never charge $20 alone)
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        if (it.variant_id === ENGRAVING_VARIANT && !(it.properties && it.properties[LINK_KEY])) {
          await fetch(root() + 'cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: it.key, quantity: 0 })
          });
          changed = true;
        }
      }

      if (changed) {
        if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
      decorateUpcart(cart);
    } catch (e) {
      /* fail quiet — never block the cart */
    } finally {
      syncing = false;
    }
  }

  /* ---------------- UpCart drawer display ---------------- */

  function upcartShadow() {
    var el = document.querySelector('#upCart');
    return el && el.shadowRoot;
  }

  function ensureHideStyle() {
    var sr = upcartShadow();
    if (!sr || sr.querySelector('#ce-upcart-style')) return;
    var st = document.createElement('style');
    st.id = 'ce-upcart-style';
    st.textContent =
      'li.upcart-internal-cart-item:has(a[href*="variant=' + ENGRAVING_VARIANT + '"]){display:none!important}' +
      '.ce-upcart-summary{font-size:12px;line-height:1.5;opacity:.75;margin-top:4px;font-style:italic}';
    sr.appendChild(st);
  }

  function decorateUpcart(cart) {
    var sr = upcartShadow();
    if (!sr) return;
    ensureHideStyle();
    if (!cart) return;
    cart.items.forEach(function (it) {
      if (it.variant_id === ENGRAVING_VARIANT) return;
      var txt = it.properties && it.properties[TEXT_KEY];
      if (!txt) return;
      var lis = sr.querySelectorAll('li.upcart-internal-cart-item');
      for (var i = 0; i < lis.length; i++) {
        var a = lis[i].querySelector('a[href*="variant="]');
        if (!a || a.getAttribute('href').indexOf('variant=' + it.variant_id) === -1) continue;
        if (lis[i].querySelector('.ce-upcart-summary')) continue;
        var font = it.properties[FONT_KEY];
        var d = document.createElement('div');
        d.className = 'ce-upcart-summary';
        d.textContent = 'Engraving: “' + txt + '”' + (font ? ' · ' + font : '') + ' · +$20.00';
        var tile = lis[i].querySelector('.upcart-internal-component-product-tile') || lis[i];
        tile.appendChild(d);
      }
    });
  }

  // Re-apply hide/summary whenever UpCart re-renders its shadow DOM.
  function watchUpcart() {
    var sr = upcartShadow();
    if (!sr) { setTimeout(watchUpcart, 500); return; }
    ensureHideStyle();
    new MutationObserver(function () {
      ensureHideStyle();
      fetch(root() + 'cart.js').then(function (r) { return r.json(); }).then(decorateUpcart).catch(function () {});
    }).observe(sr, { childList: true, subtree: true });
  }

  /* ---------------- triggers ---------------- */

  // UpCart public hooks (drawer qty buttons, removals, upsells)
  ['upcartSubscribeCartLoaded', 'upcartSubscribeCartUpdated', 'upcartSubscribeItemRemoved', 'upcartSubscribeAddedToCart', 'upcartSubscribeCartOpened']
    .forEach(function (hook) {
      var tries = 0;
      (function bind() {
        if (typeof window[hook] === 'function') window[hook](function () { syncEngraving(); });
        else if (tries++ < 20) setTimeout(bind, 500);
      })();
    });

  // Theme-side events (native drawer / cart page, if ever used)
  document.addEventListener('cart:change', syncEngraving);
  document.addEventListener('cart:refresh', syncEngraving);

  if (document.readyState !== 'loading') { syncEngraving(); watchUpcart(); }
  else document.addEventListener('DOMContentLoaded', function () { syncEngraving(); watchUpcart(); });
})();
